export enum InstituteType {
  CLOUD_SCHOOL = 1,
  CLOUD_CAMPUS = 2,
}

export interface Institute {
  type: InstituteType;
}
